import { render, staticRenderFns } from "./ModalConsultProduct.vue?vue&type=template&id=116f2f43"
import script from "./ModalConsultProduct.vue?vue&type=script&lang=js"
export * from "./ModalConsultProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports